import React from 'react';
import { Button } from 'antd';

const Download = (props: any) => {
  return (
    <div className={props.className}>
      <Button 
        onClick={()=> {console.log('aaa');
        }}
      >
        PKI登录
      </Button>
    </div>
  )
};

export default Download;
